import './Sidebar.scss'
import logos from '../Partners/Logos/index'
import React, { useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faInstagram, faLinkedin } from "@fortawesome/free-brands-svg-icons";

interface SidebarProps {
	lang: String
}

const Sidebar: React.FC<SidebarProps> = ({ lang }) => {
	const itemsPerPage = 6;
	const [currentIndex, setCurrentIndex] = React.useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setCurrentIndex((prevIndex) => (prevIndex + itemsPerPage) % Object.values(logos).length);
		}, 5000);

		return () => clearInterval(interval);
	}, []);

	const visibleLogos = Object.values(logos).slice(currentIndex, currentIndex + itemsPerPage);

	if (visibleLogos.length < itemsPerPage) {
		visibleLogos.push(...Object.values(logos).slice(0, itemsPerPage - visibleLogos.length));
	}

	return (
		<div className='calender-div col-md-2 order-md-2'>
			<div className="sidebar">
				<a className='btn' href="https://calendarlink.com/event/sRfkl">{lang === 'nl' ? 'Voeg toe aan je kalender' : 'Add to your calendar'}</a>
				{/* <a className='btn' href=''>{lang === 'nl' ? 'Nieuwsbrief' : 'Newsletter'}</a> */}
				<div className="partners">
					{visibleLogos.map((logo, index) => (
						<img key={index} src={logo} alt={`Partner ${index + 1}`} className="partner-logo" />
					))}
				</div>
				<div className="socials">
					<div className="social-row">
						<FontAwesomeIcon icon={faEnvelope} size={'xl'} />
						<a href="mailto:info@vrouwenindetop.nl" className="social-link" ><p>info@vrouwenindetop.nl</p></a>
					</div>
					<div className="social-row">
						<FontAwesomeIcon icon={faInstagram} size={'xl'} />
						<a href="https://www.instagram.com/womenat.thetop/" className="social-link"><p>womenat.thetop</p></a>
					</div>
					<div className="social-row">
						<FontAwesomeIcon icon={faLinkedin} size={'xl'} />
						<a href="https://www.linkedin.com/company/vrouwen-in-de-top/" className="social-link"><p>vrouwenindetop</p></a>
					</div>
				</div>
			</div>

		</div>
	)
}
export default Sidebar